import { render, staticRenderFns } from "./RecipientWork.vue?vue&type=template&id=40e093c8&"
import script from "./RecipientWork.vue?vue&type=script&lang=js&"
export * from "./RecipientWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports